module.exports = __webpack_public_path__ + "803e672d4a12f8260d3f493b6382aae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-blanco-unab.png
// module id = 102
// module chunks = 0